import './App.css';
import ParticlesBg from 'particles-bg';
import { useState, useRef } from 'react';
import { FaGithub, FaLaptopCode, } from 'react-icons/fa';
import { FiInstagram, FiShoppingBag, FiYoutube } from 'react-icons/fi';
import { AiOutlineDown, AiOutlineLaptop } from 'react-icons/ai';
// import { RiServerLine } from 'react-icons/ri';
import { MdOutlineChair } from 'react-icons/md';

// import { SiAntdesign } from 'react-icons/si';
// import { GiSlippers } from 'react-icons/gi';
// import { CgHeadset } from 'react-icons/cg';
// import { FaTshirt } from 'react-icons/fa';
import TextLoop from "react-text-loop";
import Typist from 'react-typist';

function App() {

	const [dark, setdark] = useState(false);
	const card = useRef(null);

	let cursor_config = {
		show: true,
		blink: true,
		element: '🔨',
		hideWhenDone: true,
	};

	function toogle() {
		setdark(!dark);
	}
	function HandleScrollDown() {
		card.current.scrollTop = card.current.scrollHeight;
	}
	return (
		<div className="d-flex content-center">

			{/* {block ?
				<a target="_blank" onClick={() => setblock()} rel="noreferrer" href="https://shp.ee/aswgeeb?smtt=0.0.9">
					<div className="ads" >

					</div>
				</a>
				: ''
			} */}
			<div className={`card ${dark ? 'dark-theme' : ''}`}>
				<div className={`toogle ${dark ? 'light' : 'dark'}`} onClick={() => toogle()}></div>
				<div className={`bg-dark ${dark ? 'active' : ''}`}></div>
				<div ref={card} className="card-body  custom-scrollbar">
					<div>
						<img className="card-avatar" src="hery.jfif" alt="avatar" />
					</div>
					<div className="card-title">
						<Typist startDelay={100} cursor={cursor_config}>
							@Try Catch<br />
							<Typist.Delay ms={500} hideWhenDone={true} hideWhenDoneDelay={true} />
							<span className="subtitle">Programmer | Content Creator.</span><br />
							<Typist.Delay ms={100} hideWhenDone={true} hideWhenDoneDelay={true} />
							<span className="subtitle">Web & Mobile Apps Development Services.</span>
						</Typist>
					</div>

					<div className="card-title">
						Familiar with{' '}
						<TextLoop interval={800}>
							<span className="text-blue">HTML.</span>
							<span className="text-blue">CSS.</span>
							<span className="text-blue">SQL.</span>
							<span className="text-blue">PHP.</span>
							<span className="text-blue">Laravel.</span>
							<span className="text-blue">Lumen.</span>
							<span className="text-blue">Javascript.</span>
							<span className="text-blue">Jquery.</span>
							<span className="text-blue">Node js.</span>
							<span className="text-blue">React js.</span>
							<span className="text-blue">React Native.</span>
							<span className="text-blue">Next js.</span>
							<span className="text-blue">Adonis js.</span>
							<span className="text-blue">Web Socket.</span>
							<span className="text-blue">Flutter.</span>
							<span className="text-blue">Python.</span>
						</TextLoop>
					</div>
					<div >
						<a target="_blank" rel="noreferrer" href="https://www.youtube.com/c/TryCatchDev?sub_confirmation=1">
							<div className="btn-action">
								<FiYoutube className='icon' />
								<span>Youtube</span>
								<span></span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://www.instagram.com/hery_herlambang_/">
							<div className="btn-action">
								<FiInstagram className='icon' />
								<span>Instagram</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/3Knpkh4qXZ">
							<div className="btn-action">
								<MdOutlineChair className='icon' />
								<span>Kursi Gaming Murah</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/XaXG5VQ0">
							<div className="btn-action">
								<AiOutlineLaptop className='icon' />
								<span>Hp Pavillion Gaming</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/7zZosMIK6j">
							<div className="btn-action">
								<AiOutlineLaptop className='icon' />
								<span>ACER NITRO 5 Core i7 16GB 512GB SSD</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/9p1T3xW9ib">
							<div className="btn-action">
								<AiOutlineLaptop className='icon' />
								<span>ACER NITRO 5 Core i5 16GB 512GB SSD</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/A9eJUV8k6a">
							<div className="btn-action">
								<AiOutlineLaptop className='icon' />
								<span>ASUS TUF i7 8GB 512GB SSD</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/7pGOkvot3g">
							<div className="btn-action">
								<AiOutlineLaptop className='icon' />
								<span>ASUS TUF i5 32GB 512GB SSD</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/1fflNEaowE">
							<div className="btn-action">
								<AiOutlineLaptop className='icon' />
								<span>MSI MODERN 14 I7 1195G7 8GB 512SSD</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/7pGOifbFab">
							<div className="btn-action">
								<AiOutlineLaptop className='icon' />
								<span>LENOVO IDEAPAD I3 8GB 512SSD</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/5pVKLk3sdF">
							<div className="btn-action">
								<AiOutlineLaptop className='icon' />
								<span>MacBook Pro (13.3 inci, M2, 2022)</span>
							</div>
						</a>
						<a id='shopee-af' target="_blank" rel="noreferrer" href="https://shp.ee/aswgeeb?smtt=0.0.9">
							<div className="btn-action">
								<FaLaptopCode className='icon' />
								<span>Alat Komputer</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shopee.co.id/shop/95848220/">
							<div className="btn-action">
								<FiShoppingBag className='icon' />
								<span>Beli Baju Programming</span>
							</div>
						</a>
						{/* <a target="_blank" rel="noreferrer" href="https://bit.ly/promopelajarNH-trycatch">
							<div className="btn-action">
								<RiServerLine className='icon' />
								<span>Diskon NiagaHoster</span>
							</div>
						</a> */}
						{/* <a target="_blank" rel="noreferrer" href="https://shope.ee/2fW6BHclDU">
							<div className="btn-action">
								<GiSlippers className='icon' />
								<span>Sendal Nationidn</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/q4S3niuJt">
							<div className="btn-action">
								<CgHeadset className='icon' />
								<span>Earphone Bluetooth Rexione</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/7pDbp7qPYp">
							<div className="btn-action">
								<FaTshirt className='icon' />
								<span>Baju Lebaran Pria</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/7pDbp7qPYp">
							<div className="btn-action">
								<FaTshirt className='icon' />
								<span>Baju Kuliah & Kerja</span>
							</div>
						</a>
						<a target="_blank" rel="noreferrer" href="https://shope.ee/3ARmHpxrMW">
							<div className="btn-action">
								<SiAntdesign className='icon' />
								<span>Jasa Creative Marketing</span>
							</div>
						</a> */}
						<a target="_blank" rel="noreferrer" href="https://github.com/try-catch-dev">
							<div className="btn-action">
								<FaGithub className='icon' />
								<span>Github</span>
							</div>
						</a>
					</div>

				</div>
				<div className='scroll-info' onClick={HandleScrollDown}> <span className='scroll-text'>Scroll Down</span ><AiOutlineDown size={12} /></div>

			</div>
			<ParticlesBg type="thick" bg={true} />

		</div>
	);
}

export default App;
